import RetailItemComm from './itemComm.retailItemComm.api';
export default RetailItemComm;
